<template>
  <div id="hotels" class="row">
    <div class="col-lg-12  col-xs-12" id="mapsNavi">
      <el-collapse v-model="interfaceCollapseActive">
        <el-collapse-item title="Filter" name="filter" v-loading="metadataLoading">
          <div class="filter-element" id="filter-destination">
            <label>Reiseziel</label>
            <el-select v-model="filter.country_id" filterable clearable @change="setCountryAndUpdateResults" placeholder="Reiseziel">
              <el-option-group v-for="region in Object.keys(metadata.countries)" :key="region" :label="$t(`regions.${region}`)">
                <el-option v-for="country in metadata.countries[region]" :key="country.id" :label="country.name" :value="country.id" />
              </el-option-group>
            </el-select>
          </div>
          <div class="filter-element" id="filter-duration">
            <label>Reisezeitraum</label>
            <el-date-picker
              v-model="filter.travel_dates"
              type="daterange"
              range-separator="-"
              start-placeholder="Anreise"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              @change="updateResults"
              end-placeholder="Abreise">
            </el-date-picker>
          </div>
          <div class="filter-element no-border" id="filter-adults">
            <label>Erwachsene</label>
            <el-input-number v-model="filter.adults" @change="updateResults" :min="1"></el-input-number>
          </div>
          <div class="filter-element  no-border" id="filter-kids">
            <label>Kinder (bis 12J)</label>
            <el-input-number v-model="filter.kids" @change="updateResults" :min="0"></el-input-number>
          </div>
          <div class="filter-element" id="filter-rooms">
            <label>{{ i18nMapLabel('roomCount') }}</label>
            <el-input-number v-model="filter.rooms" @change="updateResults" :min="1" :max="6"></el-input-number>
          </div>
          <div class="filter-element" id="filter-fare-type">
            <label>Verpflegung</label>
            <el-select v-model="filter.fare_type" filterable clearable multiple  @change="updateResults">
              <el-option v-for="fare in metadata.fare_types" :key="fare.id" :label="fare.name" :value="fare.id" />
            </el-select>
          </div>
          <div class="filter-element" id="filter-scope">
            <label>{{ i18nMapLabel('filterScope') }}</label>
            <div v-if="metadata.additional_scopes.length">
              <el-select v-model="filter.additional_scope" filterable clearable multiple  @change="updateResults">
                <el-option v-for="fare in metadata.additional_scopes" :key="fare" :label="fare" :value="fare" />
              </el-select>
            </div>
            <div v-else>
              <span class="metainfo">keine weiteren Filter vorhanden</span>
            </div>
          </div>
          <div class="filter-element no-border" id="filter-tag">
            <label>Stichwort</label>
            <div v-if="metadata.tags.length">
              <el-select v-model="filter.tags" clearable filterable multiple @change="updateResults" place>
                <el-option v-for="scope in metadata.tags" :key="scope.id" :label="scope.name" :value="scope.name" />
              </el-select>
            </div>
            <div v-else>
              <span class="metainfo">keine weiteren Filter vorhanden</span>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>


    <div class="col-lg-8 col-xs-12 maps-container" :class="`maps-zoom-${currentZoom}`" id="productMap">
      <gmap-map :center="map.mapCenter" :zoom="map.zoom" :options="{ ...map.mapOptions, styles: mapStyle }" @zoom_changed="setCurrentZoom" >
        <gmap-custom-marker
            :key="index"
            v-for="(r, index) in results"
            v-if="r.coordinates.length == 2 && resultsLoading != true"
            :marker="{lat: r.coordinates[0], lng: r.coordinates[1]}"
            :clickable="true"
            :draggable="false"
            :title="r.name"
            :label="r.name"
            :zIndex="currentResult == r.id ? 1000 : 1"
            >

          <maps-marker-content :product="r" :selected="currentResult == r.id" @click="setMapCenterForResult(r)" @close="closeMarker"></maps-marker-content>

        </gmap-custom-marker>
      </gmap-map>
    </div>
    <div class="col-lg-4  col-xs-12 maps-container" id="productList" v-loading="resultsLoading">
      <div id="resultCount" class="metainfo text-right">{{results.length}} Ergebnisse</div>
      <ul class="search-results-list">
        <li class="product-item thumb row" :class="{ selected: currentResult == product.id}" v-for="(product) in results" :data-id="product.id">
            <div class="col-sm-4 col-xs-4" @click="setMapCenterForResult(product)">
              <div class="dummy-picture pic-120 img-responsive">
                <img :src="product.product_map_image_path_cache" class="img-responsive"/>
              </div>
            </div>
            <div class="col-sm-8  col-xs-8">
              <div class="item-header">
                <h3><a :href="product.url">{{ product.name }}</a></h3>
                <b class="h4 highlight">{{product.location}}</b><br />
              </div>
              <div class="item-text">
                {{ product.produktbeschreibung_kurz }}
                <div class="text-right teaser bold">
                  <el-tooltip placement="top-end">
                    <div slot="content">
                      <div v-if="product.min_price > 0" v-html="metadata.hints.ab_preise" />
                      <div v-else  v-html="metadata.hints.anfrage_preise" />
                    </div>
                    <div>
                    <span v-if="product.min_price">ab {{ product.min_price }} EUR</span>
                    <span v-else>auf Anfrage</span>
                    <i class="el-icon-info"/>
                    </div>
                  </el-tooltip>

                </div>
                <div class="small text-right" v-if="product.min_price > 0">
                  pro Person/Nacht
                </div>
              </div>

            </div>
        </li>
      </ul>


    </div>
  </div>
</template>

<script>
import axios from 'axios'
import mapTools from './mapTools.js'
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import mapsMarkerContent from './components/marker.vue';
import ratingDisplay from './components/ratingDisplay.vue';

export default {
  mixins: [mapTools],
  components: {
    'gmap-custom-marker': GmapCustomMarker,
    'maps-marker-content': mapsMarkerContent,
    'rating-display': ratingDisplay
  },
  data: function () {
    return {
      resultsLoading: false,
      metadataLoading: true,
      metadata: {
        countries: [],
        all_countries: [],
        tags: [],
        additional_scopes: [],
        fare_types: [],
        hints: {
          ab_preise: "",
          anfrage_preise: ""
        }
      },
      results: [],
      initialResults: true,
      filter: {
        country_id: null,
        additional_scope: null,
        tags: [],
        travel_dates: [],
        fare_type: null,
        adults: 2,
        kids: 0,
        rooms: 1
      },
      currentResult: null,
      currentCountry: null,
      currentZoom: 4,
      interfaceCollapseActive: ['filter'],
      map: {
        mapCenter: { lat:52.51847983356812, lng:13.399880811721381 },
        zoom: 3,
        controlSize: 10,
        mapOptions: {
          zoomControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          scrollwheel:true
        }
      }
    }
  },

  created(){
    this.getMetadata()
    if (window.mapsPrefilter){
      this.filter = {
        ...this.filter,
        ...window.mapsPrefilter
      }
    }
    this.updateResults()
    if (window.innerWidth <= 500){
      this.interfaceCollapseActive = []
    }
  },

  computed: {
    anyFiltersSet(){
      return (this.filter.country_id || this.detailFilterSet)
    },
    detailFilterSet(){
      return this.filter.additional_scope || this.filter.tags.length || this.filter.travel_dates.length
    },
    currentResultIds(){
      return _.map(this.results, 'id')
    },
    currentTitle(){

    },
    apiUrls(){
      const baseUrl = $('#maps-mapper').data('base-url')
      const resultsAction = 'results' //(this.anyFiltersSet ? 'results' : 'recent')
      return {
        resultsUrl: `${baseUrl}/${resultsAction}.json`,
        dataUrl: `${baseUrl}/data.json`
      }
    }
  },

  methods: {
    updateResults(){

      this.resultsLoading = true
      axios.post(this.apiUrls.resultsUrl, { filter: this.filter })
      .then(r => {
        this.currentResult = null
        this.results = r.data
        this.resultsLoading = false
        this.calculateCenterFromResults()
        if (this.anyFiltersSet){
          this.initialResults = false
        }
        this.getMetadata()

      })
    },
    setCurrentZoom(val){
      this.currentZoom = val
    },
    setCountryAndUpdateResults(val){
      var country = Object.values(this.metadata.countries).flat().filter(c => c.id == val)[0]

      if (country){
        this.currentCountry = country.name
      }else{
        this.currentCountry = null
      }
      this.updateResults()
    },

    getMetadata(){
      this.metadataLoading = true
      axios.post(this.apiUrls.dataUrl, { prefilter: ((this.anyFiltersSet && !this.initialResults) ? this.currentResultIds : null ), country_id: this.filter.country_id} )
      .then(r => {
        this.metadata = r.data
        this.metadataLoading = false
        this.adjustContentHeight()
      })
    },
    setMapCenterForResult(product){
      if (product.coordinates.length == 2){
        this.map.mapCenter = {
          lat: product.coordinates[0]-0.015,
          lng: product.coordinates[1]
        }
        this.map.zoom = 14
      }
      this.currentResult = product.id

      // scroll sidebar
      var sidebar = $('#productList')
      var entry = $('#productList').find(`.product-item[data-id='${product.id}']`)

      //calc offset
      var scrollOffset = entry.offset().top - sidebar.offset().top

      sidebar.animate({scrollTop: scrollOffset }, 500)
    },

    // I18n Helper for different Product Types
    i18nMapLabel(v){
      return this.$t(`mapLabels.${window.mapsProductModel}`)[v]
    },
    closeMarker(){
      this.map.zoom = 3
      this.currentResult = {}
    }
  }

}
</script>

<style scoped>
.maps-container {
  border: solid 1px #ddd;
}
#productMap, #productList { height: 76vh; }
#productMap { padding-right: 0; padding-left: 0; }
#productList {overflow-y: scroll; overflow-x: hidden; }
.vue-map-container { height: 100%; }
</style>
